var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Pagination from '@mui/material/Pagination';
var PaginationComponent = function (_a) {
    var paginateData = _a.paginateData, totalItems = _a.totalItems, perPage = _a.perPage, currentPage = _a.currentPage, handlePageChange = _a.handlePageChange;
    if (!paginateData)
        return null;
    var pageCount = Math.ceil(totalItems / perPage);
    return (_jsx("div", __assign({ style: { display: "flex", justifyContent: "flex-end", paddingTop: "1rem" } }, { children: _jsx(Pagination, { count: pageCount, page: currentPage, onChange: handlePageChange, color: "standard", sx: {
                '& .MuiPaginationItem-root': {
                    color: '#ff8926',
                },
                '& .MuiPaginationItem-root.Mui-selected': {
                    backgroundColor: '#ff8926',
                    color: '#fff',
                },
                '& .MuiPaginationItem-root:hover': {
                    backgroundColor: '#ff8926',
                    color: '#fff',
                }
            }, showFirstButton: true, showLastButton: true }) })));
};
export default PaginationComponent;
